import BaseWidget from 'components/BaseWidget/BaseWidget';
import AirportDelaysWidget from './widgets/AirportDelaysWidget/AirportDelaysWidget';
import FireDangerWidget from './widgets/FireDangerWidget/FireDangerWidget';
import SkiReportsWidget from './widgets/SkiReportsWidget/SkiReportsWidget';

/** Selects the requested report widget and lets BaseWidget handle the dashboard shell. */
const SpecialReportsWidget = ({
  widgetType = 'fireDanger',
  dimensions,
  isLoading,
  widgetRefresh,
}) => {
  return (
    <BaseWidget
      widgetType={widgetType}
      dimensions={dimensions}
      isLoading={isLoading}
      renderers={{
        fireDanger: ({ layout, dimensions }) => (
          <FireDangerWidget layout={layout} dimensions={dimensions} widgetRefresh={widgetRefresh} />
        ),
        airportDelays: ({ layout, dimensions }) => (
          <AirportDelaysWidget
            layout={layout}
            dimensions={dimensions}
            widgetRefresh={widgetRefresh}
          />
        ),
        skiReports: ({ layout, dimensions }) => (
          <SkiReportsWidget layout={layout} dimensions={dimensions} widgetRefresh={widgetRefresh} />
        ),
      }}
    />
  );
};

export default SpecialReportsWidget;
